define('home/collections/TimelineFiltersCollection',[
    'jquery',
    'backbone',

    'core/api',

    'home/models/TimelineFilter',
], function (
    $,
    Backbone,

    api,

    Filter
) {
    'use strict';

    return Backbone.Collection.extend({

        model: Filter,

        initialize: function (_items, options) {
            options = options || {};
            this.type = options.type;
        },

        url: function () { return api.getURL('timelines/filters/list') + '?' + $.param({ type: this.type }); },

        addFilter: function (filterName) {
            var exists = this.get(filterName);
            if (!exists)
                exists = this.add({ id: filterName });
            return exists.save();
        },

        removeFilter: function (filterName) {
            var exists = this.get(filterName);
            if (!exists)
                exists = new Filter({ id: filterName });
            return exists.destroy();
        },

        parse: function (response) {
            return response.response || response;
        },
    });
});

